module.exports = __webpack_public_path__ + "static/img/left-num-row-4.be8272ef.png";